import type { AxiosInstance, AxiosRequestConfig } from "axios";
import { type OperationResponse } from "../../common.ts";
import { omitPathParameters, replacePathParameters } from "../../utils";
import type * as Paths from "./paths";

interface OperationMethods {
  "getDeliveryServices"(
    parameters: Paths.GetDeliveryServices.QueryParameters &
      Paths.GetDeliveryServices.PathParameters,
    data?: null | undefined,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.GetDeliveryServices.Responses.$200>;
  "manageDeliveryServices"(
    parameters: Paths.ManageDeliveryServices.PathParameters,
    data?: Paths.ManageDeliveryServices.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.ManageDeliveryServices.Responses.$200>;
  "getDeliveryTariffs"(
    parameters: Paths.GetDeliveryTariffs.QueryParameters &
      Paths.GetDeliveryTariffs.PathParameters,
    data?: null | undefined,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.GetDeliveryTariffs.Responses.$200>;
  "manageDeliveryTariffs"(
    parameters: Paths.ManageDeliveryTariffs.PathParameters,
    data?: Paths.ManageDeliveryTariffs.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.ManageDeliveryTariffs.Responses.$200>;
}

export const getDeliveryMethodOperations = (client: AxiosInstance) => {
  const getDeliveryServices: OperationMethods["getDeliveryServices"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/delivery-method/{id}/delivery-services";
    return client.get(replacePathParameters(url, parameters), {
      params: omitPathParameters(parameters, url),
      data: data,
      ...config,
    });
  };

  const manageDeliveryServices: OperationMethods["manageDeliveryServices"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/delivery-method/{id}/delivery-services/manage";
    return client.put(replacePathParameters(url, parameters), data, {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };

  const getDeliveryTariffs: OperationMethods["getDeliveryTariffs"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/delivery-method/{id}/delivery-tariffs";
    return client.get(replacePathParameters(url, parameters), {
      params: omitPathParameters(parameters, url),
      data: data,
      ...config,
    });
  };

  const manageDeliveryTariffs: OperationMethods["manageDeliveryTariffs"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/delivery-method/{id}/delivery-tariffs/manage";
    return client.put(replacePathParameters(url, parameters), data, {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };

  return {
    getDeliveryServices,
    manageDeliveryServices,
    getDeliveryTariffs,
    manageDeliveryTariffs,
  };
};
